// Types
import { IbanListType } from '../types/iban-list.type';
import { IbanHasChangedType } from './types/iban-selector.utils.type';

const getSelectedIbanValue = (ibanList: IbanListType): string =>
  ibanList?.find(iban => iban.selected)?.iban || '';

const ibanHasChanged = ({ oldIbanList, ibanList }: IbanHasChangedType): boolean =>
  oldIbanList?.find(iban => iban.selected)?.iban !== ibanList.find(iban => iban.selected)?.iban;

export { getSelectedIbanValue, ibanHasChanged };
